/* globals unescape,escape */
import { decodeUtf8, escapeHtml } from "./helpers";

Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {
    var API;

    API = {
        'decodeUtf8': decodeUtf8,
        murmurhash3_32_gc: function(key, seed) {
            var remainder, bytes, h1, h1b, c1, c2, k1, i;

            remainder = key.length & 3; // key.length % 4
            bytes = key.length - remainder;
            h1 = seed;
            c1 = 0xcc9e2d51;
            c2 = 0x1b873593;
            i = 0;

            while (i < bytes) {
                k1 =
                    ((key.charCodeAt(i) & 0xff)) |
                    ((key.charCodeAt(++i) & 0xff) << 8) |
                    ((key.charCodeAt(++i) & 0xff) << 16) |
                    ((key.charCodeAt(++i) & 0xff) << 24);
                ++i;

                k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
                k1 = (k1 << 15) | (k1 >>> 17);
                k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

                h1 ^= k1;
                h1 = (h1 << 13) | (h1 >>> 19);
                h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
                h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
            }

            k1 = 0;

            switch (remainder) {
                case 3:
                    k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
                /* falls through */
                case 2:
                    k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
                /* falls through */
                case 1:
                    k1 ^= (key.charCodeAt(i) & 0xff);

                    k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
                    k1 = (k1 << 15) | (k1 >>> 17);
                    k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
                    h1 ^= k1;
            }

            h1 ^= key.length;

            h1 ^= h1 >>> 16;
            h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
            h1 ^= h1 >>> 13;
            h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
            h1 ^= h1 >>> 16;

            return h1 >>> 0;
        },
        'encodeUtf8': function(s) {
            var encoded_s = s;
            try {
                encoded_s = encodeURIComponent(s);
            } catch (e) {
                try {
                    encoded_s = escape(s);
                } catch (e) {
                    encoded_s = s;
                }
            }
            return encoded_s;
        },
        'escapeHtml': escapeHtml,
        'decodeEncodeUtf8': function(s) {
            return this.encodeUtf8(decodeUtf8(s));
        },
        getAccountCurrencySymbol: function() {
            var currencyCode = (gon.current_user.currency || '').toLowerCase();
            switch (currencyCode) {
                case 'usd':
                case 'cad':
                case 'aud':
                    return '$';
                case 'gbp':
                    return '£';
                case 'eur':
                    return '€';
                case 'krw':
                    return '₩';
                default:
                    return '';
            }
        },
        // Is the Chrome extension installed, and is it running on this page?
        hasPixleeAssistant: function() {
            return $('body').hasClass('hasPixleeAssistant');
        },
        // Given a URL (queryString) with parameters, returns the value of a specified parameter (name)
        getParameterByName: function(name, queryString) {
            if (_.isFalsy(queryString)) {
                queryString = window.location.href;
            } else {
                queryString = '?' + queryString;
            }
            name = name.replace(/[[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(queryString);
            if (_.isFalsy(results)) {
                return null;
            }
            if (_.isFalsy(results[2])) {
                return '';
            }
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        },
        /******************************************************************************************************************/
        /* If you update the code below, recompress it and replace in external_analytics_js.html.erb and get_DUH.html.erb */
        /******************************************************************************************************************/
        createCookie: function(key, value, exp) {
            var date = new Date();
            date.setTime(date.getTime() + (exp * 24 * 60 * 60 * 1000));
            var expires = '; expires=' + date.toGMTString();
            var cookieValue = '=' + value + expires + '; path=/; domain=' + window.location.host.replace('www', '');
            document.cookie = key + cookieValue + '; SameSite=None; Secure';
            document.cookie = key + '_legacy' + cookieValue;
        },

        readCookieHelper: function(key) {
            var nameEQ = key + '=';
            var ca = document.cookie.split(';');
            for (var i = 0, max = ca.length; i < max; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        },

        readCookie: function(key) {
            return this.readCookieHelper(key) || this.readCookieHelper(key + '_legacy');
        },

        readFromBrowser: function(key) {
            var lsSupport = false;
            var data;

            // Check for native support
            try {
                if (window.localStorage) {
                    lsSupport = true;
                }
            } catch (e) {
                lsSupport = false;
            }

            if (lsSupport) { // Native support
                try {
                    data = window.localStorage.getItem(key);
                } catch (e) {
                    data = this.readCookie(key);
                }
            } else { // Use cookie
                data = this.readCookie(key);
            }

            return data;
        },
        storeInBrowser: function(key, value) {
            var lsSupport = false;
            var data;

            // if there is a requirement for cookie consent, don't store anything (this is specifically for photos side)
            if (gon.requireCookieConsent && !gon.acceptCookiePolicy) {
                return;
            }

            // Check for native support
            try {
                if (window.localStorage) {
                    lsSupport = true;
                }
            } catch (e) {
                lsSupport = false;
            }

            // If value is detected, set new or modify store
            if (typeof value !== 'undefined' && value !== null) {
                // Convert object values to JSON
                if (typeof value === 'object') {
                    value = JSON.stringify(value);
                }
                // Set the store
                if (lsSupport) { // Native support
                    try {
                        window.localStorage.setItem(key, value);
                    } catch (e) {
                        data = this.createCookie(key, value, 30);
                    }
                } else { // Use Cookie
                    this.createCookie(key, value, 30);
                }
            }

            // No value supplied, return value
            if (typeof value === 'undefined') {
                // Get value
                if (lsSupport) { // Native support
                    try {
                        data = window.localStorage.getItem(key);
                    } catch (e) {
                        data = this.readCookie(key);
                    }
                } else { // Use cookie
                    data = this.readCookie(key);
                }

                // Try to parse JSON...
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    /* on error, do nothing */
                }

                return data;

            }

            // Null specified, remove store
            if (value === null) {
                if (lsSupport) { // Native support
                    try {
                        window.localStorage.removeItem(key);
                    } catch (e) {
                        this.createCookie(key, '', -1);
                    }
                } else { // Use cookie
                    this.createCookie(key, '', -1);
                }
            }
        },
        getGUID: function() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();

        },
        getAnonymousId: function(anonymousId) { //optional parameter to override stored ID
            // set / remove
            if (arguments.length) {
                this.storeInBrowser('ajs_anonymous_id', anonymousId);
                return this;
            }

            // new
            anonymousId = this.readFromBrowser('ajs_anonymous_id');
            if (anonymousId) {
                return anonymousId;
            }

            // empty
            anonymousId = this.getGUID();
            this.storeInBrowser('ajs_anonymous_id', anonymousId);
            return this.readFromBrowser('ajs_anonymous_id');
        }
        /******************************************************************************************************************/
        /* If you update the code above, recompress it and replace in external_analytics_js.html.erb and get_DUH.html.erb */
        /******************************************************************************************************************/
    };

    var looksLikeHTMLTagPattern = new RegExp('<[^>]+>', 'g');
    App.reqres.setHandlers({
        'decode:utf8': function(s) {
            return decodeUtf8(s);
        },
        /**
         * Decodes a UTF8 Encoded string, as well as mangles anything that looks like an HTML tag
         * 'looks like an HTML tag' is /defined as: a < character, followed by any number of non->
         * characters, followed by a > character.
         * @param {string} s
         */
        'decode:untrusted:input': function(s) {
            var decodedString = decodeUtf8(s);

            var sanitizedString = decodedString.replace(looksLikeHTMLTagPattern, '');
            return sanitizedString;
        },
        'encode:utf8': function(s) {
            return API.encodeUtf8(s);
        },
        'escape:html': function(s) {
            return escapeHtml(s);
        },
        'murmurhash': function(key, seed) {
            return API.murmurhash3_32_gc(key, seed);
        },

        /* This might be CP only? The API function is a bit :/ though. */
        'get:anonymous:id': function() {
            return API.getAnonymousId();
        },
        'get:parameter:by:name': function(name, queryString) {
            return API.getParameterByName(name, queryString);
        },
        'store:in:browser': function(key, value) {
            return API.storeInBrowser(key, value);
        },
        'create:cookie': function(key, value, expires_in) {
            return API.createCookie(key, value, expires_in);
        },
        'get:cookie': function(key) {
            return API.readCookie(key);
        }
    });
});
